import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import axios from "axios";

import CustomDropDown from './customDropDown';

function ABSelectAddress(props) {

  //Handling TP Dropdown
  const tpDropdown = useRef();

  //Handling Initial States Floating Labels
  const [formData, setFormData] = useState({
    //[name]: null,
  });


  //Handling Floating Labels
  const handleFloatingLabels = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));

    console.log(formData);
  }

  const { type, options, attachOther, verificationType, name, id, placeholder, fieldId, isRequired, errId, caseCheckId, returnType, value, hiddenValue, selectedLabel } = props;


  ///////////////////////////////////////////////////////////

  const [selectedOptionId, setSelectedOptionId] = useState();
  const [showFilterDiv, setShowFilterDiv] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [runRequest, setRunRequest] = useState(false);
  const [autoSuggestOptionData, setAutoSuggestOption] = useState([]);
  const inputText = useRef();

  const inputTypeHandler = (e) => {
    setKeyword(e.target.value);
    setSelectedOptionId(null);
    setRunRequest(true);

    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const [currentSelectedVal, setCurrentSelectedVal] = useState(null);

  const handleThirdPartyFloatingLabel = (e) => {
    //console.log('test'+currentSelectedVal);
    let parent = e.target.parentElement;
    while (!parent.classList.contains('floating-label'))
      parent = parent.parentElement;

    if (parent.children[1].classList.contains('focused')) {
      if (currentSelectedVal !== null || value) {
        return false;
      } else {
        parent.children[1].classList.remove('focused');
        setCurrentSelectedVal(null);
      }
    } else {
      parent.children[1].classList.add('focused');
    }
  }

  useEffect(() => {

    let apiData;

    const fetchCompany = async (value) => {


      const requestData = {
        term: value,
        verification_type: verificationType,
      };
      // const headers = {
      //   "Content-Type": "application/json",
      //   Authorization: storedToken,
      // };

      const headers = {
        "Content-Type": "application/json",
        "Username": "ibridge",
        "Password": "ibridge@2020",
      };

      //   axios.defaults.baseURL = API_URL;
      apiData = await axios.post(
        "/GenericApi/getVerificationData",
        requestData,
        {
          headers,
        }
      );

      let optionsFormat = [];

      if (apiData.data.length === 0 && attachOther) {

        optionsFormat.push({ value: "other", name: "other" });

      } else {
        optionsFormat = [...apiData.data];
      }
      // let optionsFormat = [...apiData.data];
      // apiData.data.data.forEach((element, index) => {
      //   optionsFormat.push({
      //     Value: element.City.CITY_ID,
      //     Name: element.City.CITY_NAME,
      //     stateId: element.State.STATE_ID,
      //     stateName: element.State.STATE_NAME,
      //     countryId: element.Country.COUNTRY_ID,
      //     countryName: element.Country.COUNTRY_NAME,
      //   });
      // });

      //console.log(apiData);

      setAutoSuggestOption(optionsFormat);
      setShowFilterDiv(true);
    };



    if (typeof keyword == "string" && keyword.length === 0) {
      console.log("string is empty");
      setShowFilterDiv(false);
      setAutoSuggestOption([]);
      //return false;
    } else {

      //  let storedToken = userData.token;
      if (selectedOptionId === null) {
        fetchCompany(keyword);
      } else {
        setShowFilterDiv(false);
      }
    }

    //console.log(tpDropdown.current);
    //document.body.classList.add('signin');
    //let firstDiv = tpDropdown.current.children[0].children[2];
    //var classList = 'classList' in firstDiv;
    //firstDiv.classList.add('tp-main-wrapper');

    //firstDiv.classList.add('tp-main-wrapper');                                  
    //let secondDiv = tpDropdown.current.children[0].children[2].children[1];
    //var secondDivClassList = 'classList' in secondDiv;

    /*for (var i = 0; i < firstDiv.children.length; i++) {
      var child = firstDiv.children[i];
      if (child.tagName == 'DIV') {
        if (classList) {      
          child.classList.add('tp-main-wrapper');                                  
        } else {
          child.className += ' tp-main-wrapper'
        }
      }
    }*/

    //console.log(secondDiv);

    /*if (secondDiv.tagName == 'DIV') {
      if (classList) {      
        secondDiv.classList.add('tp-dropdown-arrow');                                  
      } else {
        secondDiv.className += ' tp-dropdown-arrow'
      }
    }*/
    /*for (var i = 0; i < secondDiv.children.length; i++) {
      var child = secondDiv.children[i];
      if (child.tagName == 'DIV') {
        if (classList) {      
          child.classList.add('tp-dropdown-arrow');                                  
        } else {
          child.className += ' tp-dropdown-arrow'
        }
      }
    }*/
    //console.log('ok');

    //currentTpDropdown = currentTpDropdown.parentElement;

  }, [runRequest, keyword]);

  // const selectCityHandler = (id, name) => {
  //   const index = cityData.findIndex((item) => item.Value === id);
  //   formVal5.current.value = cityData[index]["stateName"];
  //   stateIdRef.current.value = cityData[index]["stateId"];
  //   formVal6.current.value = cityData[index]["countryName"];
  //   countryIdRef.current.value = cityData[index]["countryId"];
  //   formVal4.current.value = cityData[index]["Name"];
  //   cityIdRef.current.value = cityData[index]["Value"];

  //   setSelectedCityId(id);
  //   setShowFilterCityDiv(false);
  //   setCity(name);
  // };

  const [reactSelect, setReactSelect] = useState();

  useEffect(() => {

    // let stateValue = value;
    // if (selectedLabel !== undefined) {
    //   stateValue = selectedLabel;
    // }

    let sVal = options.filter(obj => obj.value == value)

    setReactSelect(sVal);

    // setFormData(() => ({
    //   [name + "_value"]: hiddenValue,
    // }));


  }, [value]);

 //alert(JSON.stringify(value));


  useEffect(() => {

    let stateValue = value;
    if (selectedLabel !== undefined) {
      stateValue = selectedLabel;
    }

   // setReactSelect({ value: value, label: stateValue });
    setFormData(() => ({
      [name + "_value"]: hiddenValue,
    }));


  }, [hiddenValue]);



  // useEffect(() => {
  //   let stateValue = value;
  //   if(selectedLabel !== undefined){
  //     stateValue = selectedLabel;
  //   }
  //   console.log("s"+stateValue);
  //   setReactSelect({value: value, label: stateValue});

  // }, [value]);





  const handleChange = (selectedOption) => {

    // alert(JSON.stringify(selectedOption));

    setCurrentSelectedVal(selectedOption.value);

    setReactSelect(selectedOption);

    let value = selectedOption.value;
    if (returnType === 'name') {
      value = selectedOption.name;
    }

    // var value_element = document.getElementById(name+"_value");
    // value_element.value = selectedOption.value;
    setFormData((prevState) => ({
      [name + "_value"]: selectedOption.value,
    }));

    // alert(JSON.stringify(value))

    props.selectOption([{ "name": name, "value": value, "fieldId": fieldId, "isRequired": isRequired, "err_id": errId, "caseCheckId": caseCheckId }]);
    setShowFilterDiv(false);
    //setKeyword(selectedOption.name);

    if (type === 3) {

      inputText.current.value = selectedOption.name;

    }

    //if this is an auto suggeest and other is selected then do something

    if (type === 3 && selectedOption.value === 'other') {

      alert("other selected");

    }

    //if this is an auto suggeest and other is selected then do something

  };

  return (
    <>

      {(() => {
        if (
          type &&
          type === 1
        ) {
          return (
            <>
              <div className="col-sm-4 col-md-12 col-xl-4">
                <div className="form-group">
                  <div className="floating-label tp-dropdown" ref={tpDropdown}>
                    <Select
                      value={reactSelect}
                      onChange={handleChange}
                      name={name}
                      id={name}
                      options={options}
                      isSearchable={type === 2 ? true : false}
                      placeholder=""
                      onFocus={handleThirdPartyFloatingLabel}
                      onBlur={handleThirdPartyFloatingLabel}
                    // isSearchable={false}
                    />

                    <label htmlFor={id} className={(value) && 'focused'}>{placeholder} {isRequired == 1 && <sup className="text-danger">*</sup>}</label>

                   
                  </div>
                  <p className="err text-danger" id={errId}></p>
                  <input type="hidden" name={name + "_value"} id={id + "_value"} defaultValue={formData[name + "_value"]} />

                </div>
              </div>
            </>
          );
        } else if (
          type &&
          type === 3
        ) {
          return (
            <>
              <div className="col-sm-4 col-md-12 col-xl-4">
                <div className="form-group">
                  <div className="floating-label">
                    {/* <label>Course Name</label> */}
                    <input
                      type="text"
                      className="form-control"
                      name={name}
                      id={id}
                      ref={inputText}
                      onChange={inputTypeHandler}
                      autoComplete="off"
                      defaultValue={value}
                    />
                    <label htmlFor={props.id ? props.id : ''} className={(value) && 'focused'}>{placeholder}{isRequired && <sup className="text-danger">*</sup>}</label>
                  </div>
                  {showFilterDiv && (
                    <CustomDropDown
                      optionData={autoSuggestOptionData}
                      selectOption={handleChange}
                      classes="suggestion-list"
                    />
                  )}

                  <p className="err text-danger" id={errId}></p>

                  <input type="hidden" name={name + "_value"} id={id + "_value"} defaultValue={formData[name + "_value"]} />

                  {/* <input type="hidden" name="cityId" ref={cityIdRef} />
                      <p className="text-danger">{formError.formVal4}</p> */}



                </div>
              </div>


              {/* <div className="col-sm-4 col-md-12 col-xl-4">
                <div className="form-group">
                  <div className="floating-label has-left-icon">
                    <input type="text" className="form-control" name="other" id="other" onChange={handleFloatingLabels} />
                    <label htmlFor="other" className={formData.other && 'focused'}>Other<sup className="text-danger">*</sup></label>
                  </div>
                </div>
              </div> */}

            </>
          );
        }
      })()}

    </>
  );
}

export default ABSelectAddress;
